import React from 'react';
import '../App.css';
import serviceImage from '../assets/service.avif';
import Footer from '../components/Footer';

const Service = () => {
  return (
    <div className="calisthenics-page">
      {/* Hero Section */}
      <div
        className="calisthenics-banner"
        style={{ backgroundImage: `url(${serviceImage})` }}
      >
        <div className="banner-overlay"></div>
        <h2>TERMS OF SERVICE</h2>
      </div>

      {/* Terms of Service Content */}
      <div className="container blog-margin mt-5">
        <div className="blog-content mt-5">
          {/* Effective Date - Aligned with content */}
          <div className="date-section mb-4">
            <h3 className="date" style={{ fontSize: '1.2rem' }}>Effective Date: March 31, 2026</h3>
          </div>

          <p className="blog">
            
            By downloading, accessing, or using the Core Flow Fit mobile application 
            or website (collectively referred to as the “Service”), you agree to comply with and be bound by 
            these Terms of Use. If you do not agree with these terms, you should not use the Service.
          </p>

          <div>
            <h6 className="blog-h mt-3">1. Acceptance of Terms</h6>
            <p className="blog mt-2">
              Your use of the Service constitutes your agreement to all such terms, conditions, and notices. 
              Core Flow Fit reserves the right to terminate your access to the Service for any breach of these terms.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">2. Health & Fitness Disclaimer</h6>
            <p className="blog mt-2">
              Core Flow Fit provides fitness training programs, exercise demonstrations, breathwork guidance,
              and general wellness information for educational purposes only. The content provided within the
              app is not intended to replace professional medical advice, diagnosis, or treatment.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">3. Medical Clearance</h6>
            <p className="blog mt-2">
              You should consult with a qualified healthcare professional before beginning any exercise program.
              By using this app, you confirm that you are physically able to participate in physical exercise and
              assume all risks associated with such activity.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">4. Assumption of Risk</h6>
            <p className="blog mt-2">
              Participation in exercise and physical activity carries inherent risks including, but not limited to,
              muscle injury, joint injury, cardiovascular events, or other physical harm. By using Core Flow Fit,
              you voluntarily assume full responsibility for any risks, injuries, or damages that may occur.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">5. No Medical Liability</h6>
            <p className="blog mt-2">
              Core Flow Fit, its creators, instructors, partners, and affiliates shall not be held liable for any
              injuries, health issues, damages, or losses resulting from the use of the exercises, training
              programs, or wellness advice provided in the app.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">6. User Responsibility</h6>
            <p className="blog mt-2">
              You are responsible for listening to your body and performing exercises safely. If you experience
              pain, dizziness, shortness of breath, or discomfort, you should stop exercising immediately and
              seek medical advice.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">7. Intellectual Property</h6>
            <p className="blog mt-2">
              All content within the Core Flow Fit platform including videos, workouts, graphics, and written
              material is the intellectual property of Core Flow Fit and may not be copied, reproduced, distributed,
              or used without prior written permission.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">8. Account Use</h6>
            <p className="blog mt-2">
              Users are responsible for maintaining the confidentiality of their login credentials and for all
              activities that occur under their account. You agree to notify us immediately of any unauthorized 
              use of your account.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">9. Changes to Terms</h6>
            <p className="blog mt-2">
              Core Flow Fit reserves the right to update or modify these Terms of Use at any time. Updated
              versions will be posted within the application or website and are effective immediately upon posting.
            </p>
          </div>

          <div>
            <h6 className="blog-h mt-3">10. Contact Information</h6>
            <p className="blog mt-2">
              For questions regarding these Terms of Use, please contact: <br />
              <strong>Core Flow Fit</strong> <br />
              Email: <a 
                href="mailto:infocoreflowfit@gmail.com" 
                style={{ color: 'white', textDecoration: 'underline' }}
              >
                infocoreflowfit@gmail.com
              </a>
            </p>
          </div>

          <p className="bold mt-5 mb-5">
            Thank you for choosing Core Flow Fit. Train hard, stay safe, and enjoy your journey.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default Service;